export default __webpack_public_path__ + "static/media/404.ffbb0d63.png";